import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class AircraftLogbookReportActionEdit extends Component {

    constructor(props) {
        super(props);

        this.locale = getLocale();

        this.state = {
        overlay: {
            message: '',
            type: '',
            status: 'open',
        },
        redirect_url: false,
        loaded: 0,
        id: '',
        type: '',
        type_field: '',
        item_number: '',
        mel: '',
        category: '',
        limit_type: '',
        limit: '',
        limit_date: '',
        limit_hour: '',
        limit_landing: '',
        description: '',
        reason: '',
        correlation_analysis: '',
        maintenance_action: '',
        postponement: '',
        release_date: '',
        correction_date: '',
        task_card: '',
        responsible_release_id: '',
        responsible_correction_id: '',
        maintenance_operational_restriction: '',
        justification: '',
        new_date: '',
        postponement_date: '',
        document: null,
        users_list: [],
        postponements: {},
        };
        //Handlers
        this.handleAlert = this.handleAlert.bind(this);
        this.handleLoaded = this.handleLoaded.bind(this);
        this.handleMessage = this.handleMessage.bind(this);

        this.loadData = this.loadData.bind(this);
        this.edit = this.edit.bind(this);
        this.addPostponement = this.addPostponement.bind(this);
        this.approve = this.approve.bind(this);
    }
    // Handlers
    handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
    }

    handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
        change[name] = null;
        } else {
        change[name] = event.value;
        }
        this.setState(change);
    }

    handleMultiSelectChange(name, event) {
        var change = {};
        if(event == null) {
        change[name] = null;
        } else {
        change[name] = event;
        }
        this.setState(change);
    }

    handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
        var value = 1;
        } else {
        var value = 0;
        }
        change[name] = value;
        this.setState(change);
    }

    handleAlert(message, type, status, mode) {
        if(mode === 'reset') {
        this.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
        this.setState({overlay: {message: message, type: type, status: status}});
        }
    }

    handleLoaded(state) {
        if(this.state.loaded !== 2) {
        this.setState({loaded: state});
        }
    }

    handleMessage () {
        var message = localStorage.getItem("verify_message");
        if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
        localStorage.removeItem("verify_message");
        }
    }

    componentDidMount () {
        this.refs.request_api.header();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({loaded: 2}, this.loadData());
        }
    }

    loadData () {
        var self = this;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function(value) {
            var url = config.get('api') + '/aeronave/diario/acr/'+self.props.match.params.id;
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
                self.refs.request_api.validate(responseJson, 'url', '/funcoes/bordo');
                if (responseJson.status === 'success') {
                    self.setState({
                        id: responseJson.data.main.id,
                        type: responseJson.data.main.type,
                        type_field: responseJson.data.main.type_field,
                        item_number: responseJson.data.main.item_number,
                        mel: responseJson.data.main.mel,
                        category: responseJson.data.main.category,
                        limit_type: responseJson.data.main.limit_type,
                        limit: responseJson.data.main.limit,
                        limit_date: responseJson.data.main.limit_date,
                        limit_hour: responseJson.data.main.limit_hour,
                        limit_landing: responseJson.data.main.limit_landing,
                        description: responseJson.data.main.description,
                        reason: responseJson.data.main.reason,
                        correlation_analysis: responseJson.data.main.correlation_analysis,
                        maintenance_action: responseJson.data.main.maintenance_action,
                        captain_approval_date_str: responseJson.data.main.captain_approval_date_str,
                        postponement: responseJson.data.main.postponement,
                        release_date: responseJson.data.main.release_date_str,
                        correction_date: responseJson.data.main.correction_date_str,
                        task_card: responseJson.data.main.task_card,
                        responsible_release_id: responseJson.data.main.responsible_release_id,
                        responsible_correction_id: responseJson.data.main.responsible_correction_id,
                        maintenance_operational_restriction: responseJson.data.main.maintenance_operational_restriction,
                        users_list: responseJson.data.users_list,
                        postponements: responseJson.data.postponements,
                    });
                }
            }).then(() => {
                self.setState({overlay: {message: '', type: '', status: 'closed'}});
                self.handleMessage();
            });
        });
    }

    changeInput(type_field) {
        this.setState({
        type_field: type_field,
        });
    }
  
    addPostponement(event) {
        event.preventDefault();
        var data = new FormData();
        var input_document = document.querySelector(".input-document").files[0];
        data.append("document", input_document);
        data.append("date", this.state.postponement_date);
        data.append("new_date", this.state.new_date);
        data.append("justification", this.state.justification);
        data.append("aircraft_logbook_report_action_deferred_item_id", this.state.id);
    
        var header = this.refs.request_api.header();
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + '/aeronave/diario/acr/postergacao', {
              method: 'POST',
              mode: 'cors',
              headers: value,
              body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
                if(responseJson.status === 'success') {
                    self.setState({ postponements: responseJson.data });
                }
                self.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch((error) => {
              console.error(error);
            });
        });   
    }

    edit(event) {
        event.preventDefault();
        this.handleAlert('', '', 'open');
        var datasave = {
          id: this.state.id,
          postponement: this.state.postponement,
          task_card: this.state.task_card,
          responsible_release_id: this.state.responsible_release_id,
          responsible_correction_id: this.state.responsible_correction_id,
          release_date: this.state.release_date,
          correction_date: this.state.correction_date,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/item/acao/adiada', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
    }

    approve(id) {
        var confirm = "Tem certeza que deseja aprovar a postergação?";
        if(window.confirm(confirm)) {
          var datasave = {
            id: id,
          };
          this.handleAlert('', '', 'open');
          var header = this.refs.request_api.header('application/json');
          var self = this;
          var url = '/aeronave/diario/postergacao/aprovar';
          Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if(responseJson.status === 'success') {
                self.setState({ postponements: responseJson.data });
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch((error) => {
              console.error(error);
            });
          });
        }
    }
    
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
        <div className="conteudo">
        <h3 className="page-title pull-left">Edição de ACR</h3>
        <div className="grid-buttons pull-right">
            <Link to="/aeronave/diario/acrs/abertos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
        </div>
        <div className="clearfix"></div>
        <hr/>
        <form onSubmit={this.edit}>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                    <label>Type</label>
                    <Select
                        className="form-group"
                        name="type"
                        value={this.state.type}
                        searchable={true}
                        placeholder={'Selecionar'}
                        onChange={this.handleSelectChange.bind(this, 'type')}
                        options={[
                            {value: 0, label: "MEL"},
                            {value: 1, label: "NEF"},
                        ]}
                        disabled
                    />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                    <label>N° Item</label>
                    <input type="text" className="form-control" value={this.state.item_number} name="item_number" onChange={this.handleChange.bind(this, 'item_number')} placeholder="N° Item" disabled />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Categoria</label>
                        <Select
                            className="form-group"
                            name="category"
                            value={this.state.category}
                            searchable={true}
                            placeholder={'Selecionar'}
                            onChange={this.handleSelectChange.bind(this, 'category')}
                            options={[
                                {value: "a", label: "A"},
                                {value: "b", label: "B"},
                                {value: "c", label: "C"},
                                {value: "d", label: "D"},
                            ]}
                            disabled
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Tipos de limite</label>
                        <Select
                            className="form-group"
                            name="limit_type"
                            value={this.state.limit_type}
                            searchable={true}
                            placeholder={'Selecionar'}
                            onChange={this.handleSelectChange.bind(this, 'limit_type')}
                            options={[
                                {value: 0, label: "Sem limitação"},
                                {value: 1, label: "Data"},
                                {value: 2, label: "Horas de voo"},
                                {value: 3, label: "Pousos"},
                                {value: 4, label: "Específico"},
                            ]}
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                {this.state.type == 0 && 
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>MEL</label>
                            <input type="text" className="form-control" value={this.state.mel} name="mel" onChange={this.handleChange.bind(this, 'mel')} placeholder="MEL" disabled/>
                        </div>
                    </div>
                }
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Limite</label>
                        <input type="text" className="form-control" value={this.state.limit} name="limit" onChange={this.handleChange.bind(this, 'limit')} placeholder="Limite" disabled/>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Descrição</label>
                        <input type="text" className="form-control" value={this.state.description} name="description" onChange={this.handleChange.bind(this, 'description')} placeholder="Descrição" disabled/>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Motivo</label>
                        <input type="text" className="form-control" value={this.state.reason} name="reason" onChange={this.handleChange.bind(this, 'reason')} placeholder="Motivo" disabled/>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Análise de correlação</label>
                        <Select
                            className="form-group"
                            name="correlation_analysis"
                            value={this.state.correlation_analysis}
                            searchable={true}
                            placeholder={'Selecionar'}
                            onChange={this.handleSelectChange.bind(this, 'correlation_analysis')}
                            options={[
                                {value: 0, label: "N/A"},
                                {value: 1, label: "Satisfatório"},
                            ]}
                            disabled
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Restrições Operacionais</label>
                        <input type="text" name="maintenance_operational_restriction" className="form-control" placeholder="" value={this.state.maintenance_operational_restriction} onChange={this.handleChange.bind(this, 'maintenance_operational_restriction')} disabled/>
                    </div>
                </div>    
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Ação de manutenção</label>
                        <input type="text" className="form-control" value={this.state.maintenance_action} name="maintenance_action" onChange={this.handleChange.bind(this, 'maintenance_action')} placeholder="Ação de manutenção" disabled/>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Aprovação comandante</label>
                        <input type="text" className="form-control" value={this.state.captain_approval_date_str} name="captain_approval_date_str" onChange={this.handleChange.bind(this, 'captain_approval_date_str')} placeholder="" disabled/>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Postergação</label>
                        <Select
                            className="form-group"
                            name="postponement"
                            value={this.state.postponement}
                            searchable={true}
                            placeholder={'Selecionar'}
                            onChange={this.handleSelectChange.bind(this, 'postponement')}
                            options={[
                                {value: 0, label: "Não"},
                                {value: 1, label: "Sim"},
                            ]}
                            required={(this.state.category !== 'b' && this.state.category !== 'c') ? false : true}
                            disabled={(this.state.category !== 'b' && this.state.category !== 'c') ? true : false}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Task Card</label>
                        <input type="text" className="form-control" value={this.state.task_card} name="task_card" onChange={this.handleChange.bind(this, 'task_card')} placeholder="Task Card" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Responsável pela liberação</label>
                        <Select
                            className="form-group"
                            name="responsible_release_id"
                            value={this.state.responsible_release_id}
                            searchable={true}
                            placeholder={'Selecionar'}
                            onChange={this.handleSelectChange.bind(this, 'responsible_release_id')}
                            options={this.state.users_list}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Data de liberação</label>
                        <InputMask value={this.state.release_date} name="release_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'release_date')} placeholder="dd/mm/yyyy hh:mm" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Responsável pela correção</label>
                        <Select
                            className="form-group"
                            name="responsible_correction_id"
                            value={this.state.responsible_correction_id}
                            searchable={true}
                            placeholder={'Selecionar'}
                            onChange={this.handleSelectChange.bind(this, 'responsible_correction_id')}
                            options={this.state.users_list}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Data de correção</label>
                        <InputMask value={this.state.correction_date} name="correction_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'correction_date')} placeholder="dd/mm/yyyy hh:mm" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Salvar</button>
                    </div>
                </div>
            </div>
        </form>
        <hr />
        {this.state.category == 'b' || this.state.category == 'c'
        ?
            <div>
                <h3>Postergação</h3>
                <form onSubmit={this.addPostponement}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Data:</label>
                                <InputMask value={this.state.postponement_date} name="postponement_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'postponement_date')} placeholder="dd/mm/yyyy hh:mm" required />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Novo prazo:</label>
                                <InputMask value={this.state.new_date} name="new_date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'new_date')} placeholder="dd/mm/yyyy hh:mm" required />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Documento que autoriza a postergação:</label>
                                <input type="file" name="document" className="form-control input-document" placeholder='Documento' value={this.state.document} onChange={this.handleChange.bind(this, 'document')} required />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Justificativa:</label>
                                <textarea style={{ height: 100 }} type="text" name="justification" className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} required />
                            </div>
                        </div>

                    </div>
                    <div>
                        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Salvar postergação</button>
                    </div>
                </form>
                <hr/>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped">
                        <thead>
                            <tr>
                                <th className="text-center vcenter">Data</th>
                                <th className="text-center vcenter">Justificativa</th>
                                <th className="text-center vcenter">Novo prazo</th>
                                <th className="text-center vcenter">Data da aprovação</th>
                                <th className="text-center vcenter">Aprovação do responsável pela postergação</th>
                                <th className="text-center vcenter">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(self.state.postponements).map(function(k) {
                                var postponement = self.state.postponements[k];
                                var responsible_name = '';
                                if (postponement.responsible_id) {
                                    responsible_name = postponement.responsible.name;
                                }
                                return (
                                <tr>
                                    <td className="text-center vcenter">{postponement.date_str}</td>
                                    <td className="text-center vcenter">{postponement.justification}</td>
                                    <td className="text-center vcenter">{postponement.new_date_str}</td>
                                    <td className="text-center vcenter">{postponement.approval_date_str}</td>
                                    <td className="text-center vcenter">{responsible_name}</td>
                                    <td className="text-center vcenter">
                                    {
                                        (postponement.responsible_id) ?
                                        <div className="btn-group text-center">
                                            {typeof postponement.document != 'undefined' &&
                                                <a className={"btn btn-sm btn-warning button-inline"} target="_blank" href={config.get('cdn') + '/files/deferred_item_postponements/' + postponement.document}><i className="fa fa-fw fa-download"></i></a>
                                            }
                                            <button className="btn btn-success btn-sm button-inline" disabled><i className="fa fa-check"></i></button>
                                        </div>
                                        :
                                        <div className="btn-group text-center">
                                            {typeof postponement.document != 'undefined' &&
                                                <a className={"btn btn-sm btn-warning button-inline"} target="_blank" href={config.get('cdn') + '/files/deferred_item_postponements/' + postponement.document}><i className="fa fa-fw fa-download"></i></a>
                                            }
                                            <button onClick={() => self.approve(postponement.id)} className="btn btn-success btn-sm button-inline"><i className="fa fa-check"></i> Aprovar</button>
                                        </div>
                                        }
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div> 
        : ''
        }
        <hr />
    </div>
  </div>
</div>
    );
  }
}

export default AircraftLogbookReportActionEdit;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbookReportActionDeferredItems/AircraftLogbookReportActionEdit.js